export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccionar cuenta del oferente"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuenta del oferente"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}